import "angular";
import uiRouter from "angular-ui-router";

import Common from "./common/common";
import Components from "./components/components";
import AppComponent from "./app.component";
import "ngstorage";
import "angular-cookies";
import "angular-animate";
import "angular-sanitize";
import "ng-file-upload";
import "angular-base64";
import "angular-image-compress";
import "ngmap";
import "angular-chosen-localytics";
import "angular-typeahead";
import "ng-infinite-scroll";
import "./directives/angular-file-model";
import "ng-csv";
import "angular-screenshot/build/angular-screenshot.min";
import services from "./services/services";
import filters from "./filters/filters";
import directives from "./directives/directives";
import angulartics from "angulartics";
import google_angulartics from "angulartics-google-analytics";
import configFile from "../../configFile";

angular
  .module("app", [
    uiRouter,
    "angulartics",
    google_angulartics,
    "datetime",
    "ngStorage",
    "ngCookies",
    "ngAnimate",
    "ngImageCompress",
    "ngSanitize",
    "localytics.directives",
    "ngFileUpload",
    "siyfion.sfTypeahead",
    "angular-screenshot",
    "ngMap",
    "infinite-scroll",
    "ngProgress",
    "base64",
    "ngCsv",
    "file-model",
    Common.name,
    Components.name,
    services.name,
    filters.name,
    directives.name,
    "myApp.config",
  ])
  .config(($locationProvider, $httpProvider, $stateProvider, $injector, waf_silent_challenge_js_sdk_enabled) => {
    "ngInject";
    $httpProvider.interceptors.push(function ($q) {
      return {
        request: function (config) {
          if (config.method === "PUT") {
            if (config.url.indexOf("/events/") > -1) {
              config.data.subEvents = undefined;
              config.data.startTimeFormatted = undefined;
              config.data.endTimeFormatted = undefined;
              config.data.eventTypeId = undefined;
              config.data.eventTypeName = undefined;
              config.data.companyId = undefined;
              config.data.companyName = undefined;
              config.data.companyDescription = undefined;
              config.data.companyIndustryTypeName = undefined;
              config.data.cost = undefined;
              config.data.numberOfOpenings = undefined;
              config.data.totalNumberOfJobbles = undefined;
              config.data.totalNumberOfApplications = undefined;
              config.data.numberOfApprovedApplications = undefined;
              config.data.numberOfPendingApplications = undefined;
              config.data.numberOfRejectedApplications = undefined;
              config.data.numberOfSubEvents = undefined;
              config.data.payPerHourRounded = undefined;
            } else if (config.url.indexOf("/subevents/") > -1) {
              config.data.eventId = undefined;
              config.data.eventName = undefined;
              config.data.eventTypeName = undefined;
              config.data.startTime = undefined;
              config.data.endTime = undefined;
              config.data.nonDuplicatedJobbles = undefined;
              config.data.applications = undefined;
              config.data.numberOfOpenings = undefined;
              config.data.totalNumberOfJobbles = undefined;
              config.data.totalNumberOfApplications = undefined;
              config.data.numberOfApprovedApplications = undefined;
              config.data.numberOfPendingApplications = undefined;
              config.data.numberOfRejectedApplications = undefined;
            } else if (config.url.indexOf("/users/") > -1) {
              if (config.data.company) {
                config.data.company.files = undefined;
              }
              config.data.files = undefined;
              config.data.roles = undefined;
            }
          }

          return config;
        },

        response: function (response) {
          if (response.status === 401) {
            console.log("do we get a 401?");
            console.dir(401);
            window.location = "/signin";
          }
          return response;
        },
      };
    });

    if (window.origin) {
      if (window.origin.indexOf("dev2.int") > -1 || window.origin.indexOf("localhost") > -1) {
      } else {
        $httpProvider.defaults.withCredentials = true;
      }
    } else if (window.location.origin) {
      if (window.location.origin.indexOf("dev2.int") > -1 || window.location.origin.indexOf("localhost") > -1) {
      } else {
        $httpProvider.defaults.withCredentials = true;
      }
    }

    $httpProvider.interceptors.push(function ($q) {
      return {
        request: function (request) {
          if (!waf_silent_challenge_js_sdk_enabled) {
            return request;
          }

          return window.AwsWafIntegration.getToken()
            .then(function (token) {
              request.headers['x-aws-waf-token'] = token;
              return request;
            })
            .catch(function (error) {
              return request;
            });
        },
        response: function (response) {
          return response;
        }
      };
    });

    //@see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix("!");
  })
  .run(($rootScope, $state) => {
    "ngInject";
    $rootScope.$on("$stateChangeSuccess", function (event, toState, toParams, fromState, fromParams) {
      const title = $state.current.title ? " - " + $state.current.title : "";
      document.title = "Jobble" + title;
    });
  })
  .component("app", AppComponent);



// WEBPACK FOOTER //
// ./client/app/app.js